import type { CatalogueEntry } from './types';

/** Polish name of an action, taken from the catalogue the server sends (labels are mandatory there). */
export const actionLabel = (entry: CatalogueEntry, action: string): string => entry.actionLabels[action] ?? action;
